import React, { Component } from 'react';
import './HistoricoPedido.css'
import services from './../../services/index'
import ListHistorico from './../../components/listHistorico/ListHistorico';
import Loading from './../../components/loading/Loading';
import Header from './../../components/header/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { Redirect } from 'react-router-dom';


export default class historicoPedido extends Component {



  state = {
    pedidos: [],
    loadingPage: false,
    openModal: false,
    itens: [],
    codigo_pedido: 0,
    total_pedido: 0,
    redirect: false,
    logado: false,

  }


  async componentDidMount() {


    this.setState({ loadingPage: true });
    let logado = await services.isLogado();

    if (!logado) {
      this.setState({ redirect: true, loadingPage: false });
      return
    } else {
      this.setState({ logado: true, loadingPage: false });
    }

    try {
      this.setState({ loadingPage: true });
      let pedidos = await services.getHistorico();

      if (pedidos) this.setState({ pedidos: pedidos, loadingPage: false })
      else this.setState({ loadingPage: false });
    } catch (error) {
      this.setState({ loadingPage: false, redirect: true });
    }

  }

  repetirPedido = async (codigo_pedido) => {
    this.setState({ loadingPage: true })
    let objPedido = await services.getItensPedido(codigo_pedido);
    if (objPedido) {
      const { token } = services.getUser();
      services.enviaPedido(objPedido, token);
    }
    this.setState({ loadingPage: false });
  }


  openPedido = async (codigo_pedido) => {
    try {
      this.setState({ loadingPage: true });
      let objPedido = await services.getItensPedido(codigo_pedido);
      console.log(objPedido)
      if (objPedido) this.setState({
        itens: objPedido.itens,
        codigo_pedido: codigo_pedido,
        openModal: true,
        total_pedido: objPedido.subtotal
      });



      this.setState({ loadingPage: false });

    } catch (error) {
      console.log(error);
      this.setState({ loadingPage: false });
    }

  }

  closeModal = () => {
    this.setState({ itens: [], openModal: false, codigo_pedido: 0 });
  }


  render() {
    if (this.state.redirect) {
      return <Redirect to={{ pathname: '/', state: { from: '/' } }} />
    }

    if (this.state.loadingPage) {
      return <Loading />
    } else {


      return (
        <div>
          <Header logado={this.state.logado} />
          <div className="content-historico">
            <div className="container" >
              <ListHistorico pedidos={this.state.pedidos} openPedido={this.openPedido} repetirPedido={this.repetirPedido} />
            </div>


            <Modal show={this.state.openModal} onHide={this.closeModal} className="customModal">
              <FontAwesomeIcon icon={faTimesCircle} className="faTimes faTimesHistorico pull-right" onClick={this.closeModal} />
              <div className="content-itens-meus-pedidos">
                <span id="infNumPedido">Pedido #{this.state.codigo_pedido}</span>
                {

                  this.state.itens.map((item, index) => {
                    return (
                      <div key={index} className="divSeparator">
                        <div className="row">
                          <div className="col-md-9 col-sm-9 col-xs-7">
                            <label htmlFor={`prod${index}`}>{`${item.quantidade}x  ${item.nome_produto}`}</label>
                          </div>
                          <div className="col-md-3 col-sm-3 col-xs-5">
                            <p className="text-right">R$ {item.combo === "S" ? item.total.toFixed(2) : item.preco.toFixed(2)}</p>
                          </div>
                        </div>

                        {
                          item.borda.borda ? (
                            <div >

                              <div className="row paddingTopClass">
                                <div className="col-md-12">
                                  <p style={{ paddingLeft: '10px' }}><strong>Borda -> </strong>{item.borda.borda}  {item.borda.preco ? `( R$ ${item.borda.preco.toFixed(2)} )` : ""}</p>
                                </div>
                              </div>



                            </div>
                          ) : ''
                        }

                        {
                          item.massa.massa ? (
                            <div >
                              <div className="row paddingTopClass">
                                <div className="col-md-12">
                                  <p style={{ paddingLeft: '10px' }}><strong>Massa -> </strong>{item.massa.massa}  {item.massa.preco ? `( R$ ${item.massa.preco.toFixed(2)} )` : ""}</p>
                                </div>
                              </div>
                            </div>
                          ) : ''
                        }

                        {
                          item.subitens ? (
                            <div >
                              {
                                item.subitens.map((sub, index) => {
                                  return (
                                    <div className="row paddingTopClass" key={index}>
                                      <div className="col-md-12">
                                        <p style={{ paddingLeft: '10px' }}>{sub.nome_produto} {sub.preco ? `( R$ ${sub.preco.toFixed(2)} )` : ""}</p>
                                      </div>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          ) : ''
                        }

                        {
                          item.extras ? (
                            <div >
                              {
                                item.extras.map((extras, index) => {
                                  return (
                                    <div className="row paddingTopClass" key={index}>
                                      <div className="col-md-12">
                                        <p style={{ paddingLeft: '10px' }}>+{extras.nome_produto} {extras.preco ? `(  R$ ${extras.preco.toFixed(2)}  )` : ""}</p>
                                      </div>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          ) : ''
                        }

                      </div>
                    );
                  })
                }
              </div>
              <Modal.Footer className="customFooterModal footerModalAdd">
                <p id="totHistoricoItens">R$ {this.state.total_pedido ? this.state.total_pedido.toFixed(2) : this.state.total_pedido}</p>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      );
    }
  }
}
